<template>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="textcard">
      <h2>24/7 uptime monitoring</h2>
      <br>
      <p>Even our robust datacenter proxy network experiences minor problems from time to time.
        Therefore ProxyScrape has an amazing monitoring team on stand-by that solves any network
        problem that may happen to ensure you get the best possible proxy quality 24/7.
        We maintain our proxies to support small and big projects alike!</p>
      <a href="#pricing" style="font-weight: 600; text-decoration: none;">
        See pricing
        <img alt="" src='@/assets/img/svg/right-arrow.svg' style="height: 14px;">
      </a>
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
